var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-request-viewer" }, [
    _c("header", { staticClass: "form-request-toolbar" }, [
      _c("div", { staticClass: "form-identity" }, [
        _c(
          "span",
          { staticClass: "form-mark", attrs: { "aria-hidden": "true" } },
          [_c("portal-icon", { attrs: { name: "file-text", size: 19 } })],
          1
        ),
        _c("div", { staticClass: "form-title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.request.name))]),
          _c("span", [_vm._v(_vm._s(_vm.$t("forms.submissions.incomplete")))])
        ])
      ]),
      _c(
        "button",
        {
          staticClass: "round-action",
          attrs: {
            type: "button",
            "aria-label": _vm.$t("global.close"),
            title: _vm.$t("global.close")
          },
          on: { click: _vm.handleClose }
        },
        [_c("portal-icon", { attrs: { name: "x", size: 19 } })],
        1
      )
    ]),
    _c(
      "main",
      { staticClass: "form-request-body show-scrollbar" },
      [
        _vm.token
          ? _c("discovery-form", {
              attrs: { "request-token": _vm.token },
              on: {
                result: function($event) {
                  return _vm.$emit("result", $event)
                }
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }